<template>
  <div class="monthly-date-picker">
            <div class="month-calendar-header">
                {{year}}年{{month + 1}}月
            </div>
            <div class="month-calendar-ctn">
                     <span v-for="weekday in weeks" :key="weekday" class="month-calendar-cell header">
                        {{weekday}}
                      </span>
                    <span v-for="dateItem in daysInMonthFormated" 
                                 :class="calendarCellCls(dateItem)"
                                 :key="dateItem.timestamp"
                                 @click="onClickDateHandler(dateItem)">
                        <span class="month-canlendar-cell-inner">
                          {{dateItem.date}}
                        </span>
                        <span v-if="selectedTimes"
                            class="day-course-times">
                            {{selectedTimes[dateItem.tempFmt] && selectedTimes[dateItem.tempFmt].length > 0 ? selectedTimes[dateItem.tempFmt].length : ''}}
                        </span>
                    </span>
            </div>

            <!--时段选择-->
            <div class="choose-time-line" v-if="openCell == true && curMonth === month">
                <div class="plr10 txt-lh24 clearfix">
                    <span class="ptb10 txt-999 fl">选择意向课次时段</span>
                    <span v-if="groupLimit>1" class="ptb10 txt-orange fl">（可多选）</span>
                    <span class="close-btn fr" @click="onCloseChoose"></span>
                </div>
                <PeriodPicker 
                  :list="periods()"
                  :rate="timesheetInfo.rate"
                  :isMulti="true"
                  :checkedList="checkedPeriods()"
                  :startDate="timesheetInfo.startDate"
                  :endDate="timesheetInfo.endDate"
                  :datesGroup="timesheetInfo.datesGroup"
                  :groupId="datesGroupSelectedStart && datesGroupSelectedStart.groupId"
                  @onChangePeriodHandler = "onChangePeriodHandler"
                  >
                  </PeriodPicker>

            </div>
        </div>
</template>
<script>
import {mapState} from 'vuex';
import PeriodPicker from './PeriodPicker'
export default {
  name: 'IrrMonthlyDatePicker',
  props: {
    year: Number,
    month: Number,
    rate: Number,
    datesGroup: Array,
    selectMode: String,
    datesGroupSelectedStart: Object,
    datesGroupSelectedEnd: Object,
    selectedDateGroupMap: Object,
    groupLimit: Number,
    curDate: String,
    curMonth: Number
  },
  components: {
    PeriodPicker
  },
  data(){
    return {
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      daysInMonthFormated: [],
      openCell: false
    }
  },
  computed: mapState({
    stageRangeList: state => state.newsign.stageRangeList,
    dateRangeList: state => state.newsign.dateRangeList,
    timesheetInfo: state => state.newsign.timesheetInfo,
    submitForm: state => state.newsign.submitForm,
    selectedTimes: state => state.newsign.irrSelectedTimeInfo
  }),
  methods: {
      init (){
        //按月取日历
        var daysInMonth = this.getDaysInMonth(this.month, this.year);//获取当前月份有多少天
        var monthStartDate = new Date(this.year, this.month, 1);//月份开始的日期
        var monthEndDate = new Date(this.year, this.month, daysInMonth);//月份结尾的日期
        var daysInMonth = this.getAllDays(monthStartDate, monthEndDate);//一个月的所有信息
        var predays = [];//填充开始的日期之前的

        if (daysInMonth[0].day != 0) { //开始日期是星期几 如周三
            for (var i = 0; i < daysInMonth[0].day; i++) {
                var temp = new Date(daysInMonth[0].timestamp - 1000 * 3600 * 24 * (i + 1));
                var tempFmt = utils.formatDate(temp, 'yyyy-MM-dd');
                predays.unshift({
                    tempFmt: tempFmt,
                    timestamp: temp.valueOf(),
                    month: temp.getMonth(),
                    date: temp.getDate(),
                    day: temp.getDay(),
                    isPre: true
                });
            }
        }
        this.daysInMonthFormated = predays.concat(daysInMonth);
    },
      getAllDays(startDate, endDate){
        var result = [];
        for (var k = startDate.valueOf(); k <= endDate.valueOf();) { //循环当月的所有日期

            var temp = new Date(k);//月份开始的日期

            var tempFmt = utils.formatDate(temp, 'yyyy-MM-dd');
            var inDateGroup = _.find(this.datesGroup, {date: tempFmt});//找到日期是不是在headers里面
            if (inDateGroup) {
                result.push({
                    tempFmt: tempFmt,
                    year: temp.getFullYear(), // 年
                    timestamp: temp.valueOf(), // 时间戳
                    month: temp.getMonth(), // 月
                    date: temp.getDate(), // 日
                    day: temp.getDay(), // 星期几
                    dateType: inDateGroup.dateType, // 是否可选
                    dateMsg: inDateGroup.dayMsg,
                    groupId: inDateGroup.groupId, // 课程id
                    highlight: inDateGroup.highlight// 表头是否高亮
                });
            } else {
                result.push({
                    tempFmt: tempFmt,
                    dateType: 0, //当前日期不可选
                    year: temp.getFullYear(), //年
                    timestamp: temp.valueOf(), //时间戳
                    month: temp.getMonth(), //月
                    date: temp.getDate(), //日
                    day: temp.getDay(), //星期几
                    highlight: 0//表头不高亮
                });
            }

            k = k + 1000 * 60 * 60 * 24;//month+1
        }
        return result;
    },
    getDaysInMonth(month, year){
        var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if ((month == 1) && (year % 4 == 0) && ((year % 100 != 0) || (year % 400 == 0))) {
            return 29;
        } else {
            return daysInMonth[month];
        }
    },
    periods(){
      var periods = _.filter(this.timesheetInfo.cells, {date: this.curDate})
      return periods;
    },
    checkedPeriods(){
      var times = this.selectedTimes[this.curDate];
      var periods = _.map(times, item => {
        return item.time
      })
      return periods
    },
    onCloseChoose(){
      this.openCell = false;
    },
    onClickDateHandler(date, e){
        if (date.highlight) {
          this.openCell = true;
          this.$emit('onDateChangeHandler', date);
        }
    },
    /**
     * 更新选择的时段信息，数据结构形如：
     * {
     *   '2019-08-12':['08:00~10:00',13:00~15:00],
     *   '2019-09-10':['10:00~12:00']
     * }
     * @method onChangePeriodHandler
     * @param {Object} period 时段信息
     * 若当前日期已经选中时段，取消该时段，
     * 若当前日期尚未选中改时段，加入该时段
     */
    onChangePeriodHandler(period){
      var timeMap = JSON.parse(JSON.stringify(this.selectedTimes));
      var times  = _.flatten(_.values(timeMap));
      if (times.length >= this.groupLimit){
        this.$store.dispatch('toast', {title: '课次已选满', show: true});
        return;
      }
      if (timeMap[this.curDate]){
        var idx = _.findIndex(timeMap[this.curDate], (item) => {
          return item.time === period.time
        });
        if (idx>-1){
          timeMap[this.curDate].splice(idx, 1);
        } else {
          timeMap[this.curDate].push(period);
        }
      } else {
        timeMap[this.curDate] = [period];
      }
      this.$store.commit('updateIrrSelectedTimeInfo', timeMap);
    },
    selectable(date){
        return this.selectedTimes[date.tempFmt]&&this.selectedTimes[date.tempFmt].length>0
    },
    selectTab(cell){

    },
    timePeriodCellCls(cell){
      return ["item", {
                  hasOccupy: cell.canSelect == 0,
                  selected: this.selectTab(cell)
              }]
    },
    calendarCellCls(dateItem){
      return ["month-calendar-cell", {
                        today: dateItem.today,
                        start: dateItem.day == 0,
                        prev: dateItem.isPre,
                        disabled: dateItem.highlight == 0,
                        hasSelected: this.selectable(dateItem),
                        active: !dateItem.isPre && this.curDate == dateItem.tempFmt
                    }]
    }
  },
  mounted(){
    this.init();
    console.log(this.curDate);
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/IrrMonthlyDatePicker.vue